import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';

/** Page screenshot for a manual tile; hides itself if the image isn't available. */
export const ManualShot = ({ id, title }) => {
  const [missing, setMissing] = useState(false);
  const [zoom, setZoom] = useState(false);
  if (missing) return null;
  const src = `/manual/${id}.jpg`;
  return (
    <>
      <figure className="mt-3 rounded-lg border border-gray-200 overflow-hidden bg-gray-50 break-inside-avoid" data-testid={`help-shot-${id}`}>
        <button type="button" onClick={() => setZoom(true)} className="group relative block w-full text-left no-print-click" aria-label={`Enlarge screenshot of ${title}`} data-testid={`help-shot-zoom-${id}`}>
          <img src={src} alt={`${title} screen`} loading="lazy" onError={() => setMissing(true)} className="w-full h-auto max-h-72 object-cover object-top block" />
          <span className="no-print absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-full bg-black/60 text-white text-[11px] px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity"><ZoomIn className="w-3 h-3" /> Enlarge</span>
        </button>
        <figcaption className="px-3 py-1.5 text-[11px] text-gray-500 border-t border-gray-200">What the {title} screen looks like</figcaption>
      </figure>
      {zoom && (
        <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4 no-print" onClick={() => setZoom(false)} data-testid={`help-shot-lightbox-${id}`}>
          <button type="button" className="absolute top-4 right-4 text-white/80 hover:text-white" aria-label="Close" onClick={() => setZoom(false)}><X className="w-7 h-7" /></button>
          <img src={src} alt={`${title} screen`} className="max-w-full max-h-full rounded-lg shadow-2xl" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
};
